<div class="save-prompt-detail-container">
    <div class="save-prompt-detail">
        <div class="header">
            <button class="back-button" (click)="closeSaveCurrentPromptModal()">
                <img src="../assets/icons/arrows/arrowLeft.svg" alt="Back">
            </button>
        </div>
        <div class="prompt-info">
            <div class="prompt-title-wrapper">
                <label for="prompt-title"><b>Title <span class="mandatory-field-asterisk">*</span></b></label>
                <small class="text-muted ml-2" style="float: right;">
                    {{promptTitle ? promptTitle.length : 0}}/50
                </small>
                <input id="prompt-title" type="text" [value]="promptTitle" [(ngModel)]="promptTitle" maxlength="50">
                <div *ngIf="!isPromptTitleValid" class="error-message">Prompt title cannot be empty. Please enter your title before saving.</div>
            </div>
            <div class="prompt-description-wrapper">
                <label for="prompt-description"><b>Prompt <span class="mandatory-field-asterisk">*</span></b></label>
                <small class="text-muted ml-2" style="float: right;">
                    {{promptDescription ? promptDescription.length : 0}}/5000
                </small>
                <textarea id="prompt-description" [value]="promptDescription"
                    [(ngModel)]="promptDescription" maxlength="5000"></textarea>
                <div *ngIf="!isPromptDescriptionValid" class="error-message">Prompt content cannot be empty. Please enter your prompt before saving.</div>
            </div>
        </div>
        <div class="controls">
            <button kmdInfoButton (click)="closeSaveCurrentPromptModal()">Cancel</button>
            <button kmdFeaturedButton [disabled]="!isFormValid() || loading" (click)="savePrivatePrompt()">Save prompt</button>
        </div>
    </div>
</div>